import { EDPCompanyColloquial } from '../edp/colloquials';
import { Colloquial } from './abstract-colloquial.class';

export class CompanyColloquial extends Colloquial {
  alternativeCompanyName: string;

  static fromEDPColloquialArray(edpCompanyColloquials: EDPCompanyColloquial[]): CompanyColloquial[] {
    return (edpCompanyColloquials || []).map<CompanyColloquial>(
      edpCompanyColloquial => new CompanyColloquial(edpCompanyColloquial)
    );
  }

  static toEDPColloquialArray(companyColloquials: CompanyColloquial[]): EDPCompanyColloquial[] {
    return companyColloquials.map<EDPCompanyColloquial>(companyColloquial => companyColloquial.toEDPColloquial());
  }

  constructor({ id, country_code_desc, language_desc, alternative_company_name }: EDPCompanyColloquial) {
    super(id, country_code_desc, language_desc);
    this.alternativeCompanyName = alternative_company_name;
  }

  toEDPColloquial(): EDPCompanyColloquial {
    const { id, countryCodeDesc, languageDesc, alternativeCompanyName } = this;
    return {
      id,
      country_code_desc: countryCodeDesc,
      language_desc: languageDesc,
      alternative_company_name: alternativeCompanyName,
    };
  }
}
